module.exports = __webpack_public_path__ + "img/strategy-active.5a7a04f6.svg";